// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Information.info-baseline .description-textarea {
  height: 100px;
}`, "",{"version":3,"sources":["webpack://./src/web/client/src/components/Programs/Baselines/Sidebar/Content/Information.scss"],"names":[],"mappings":"AAEE;EACE,aAAA;AADJ","sourcesContent":[".Information.info-baseline {\n\n  .description-textarea {\n    height: 100px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
